<template>
  <div class="widthContent">
    <PageBanner url="https://www.yueyilan.com/img-yueyilan/upload/photo/zsyf/jituan.png" title="公司概况"/>
    <div class="middleContent">
        <BreadList :active="$route.params.type" :info="breadList"/>
        <p class="title">{{breadList[$route.params.type-1].title}}</p>
        <p class="desc">{{breadList[$route.params.type-1].en}}</p>
        <div class="contentHtml" v-html="htmlText"></div>
    </div>
    <Swiper :listInfo="swiperData" v-if="$route.params.type=='4'" />
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner'
import BreadList from './BreadLink'
import link from '@/link.js'
import api from '@/api/api'
import Swiper from '@/components/department/swiper'
export default {
  name: 'index',
  components:{
    PageBanner,
    BreadList,
    Swiper
  },
  data () {
    return {
      breadList:link[1].list,
      htmlText:"",
      swiperData:[]
    }
  },
  watch:{
    $route(){
      this.getData();
    }
  },
  methods:{
    getData(){
      api.getCompanyInfo({
        subType:this.$route.params.type,
        type:"1"
      }).then(res=>{
        if(res.data.code===0){
          this.htmlText = res.data.data.news.text;
          this.swiperData = res.data.data.honor;
        }else{
          this.htmlText="暂时没有数据！"
        }
        
      })
    }
  },
  created(){
    this.getData();
  }
}
</script>
<style lang="scss" scoped>
    .middleContent{
        .title{
            width: 100%;
            line-height: 34px;
            font-size: 28px;
            font-weight: bold;
            margin-top: 30px;
        }
        .desc{
            font-size: 16px;
            line-height: 24px;
            color: #909399;
            margin-top: 12px;
            padding-bottom: 22px;
        }
    }
  @media screen and (max-width: 1200px){
      .middleContent{
        .title{
          font-size: 24px;
        }
        .desc{
          font-size: 14px;
        }
      }
    }
</style>





// WEBPACK FOOTER //
// src/components/Introduction.vue